import { SamplesLanguages } from 'types/enums';

export const getIsSupportedLocale = (
    locale: SamplesLanguages | string | undefined,
): locale is SamplesLanguages => {
    if (!locale) return false;

    return Object.values(SamplesLanguages).some(
        (supportedLocale) => supportedLocale === locale,
    );
};
